<template>
  <button
    v-if="userComputed"
    v-b-tooltip="'Nhấn để xem chi tiết'"
    class="button button-to-link"
    @click="modalVisible = true"
  >
    {{ userComputed.name }}
    <b-modal title="Thông tin tài khoản" v-model="modalVisible" ok-only centered>
      <div class="c-template-table table-responsive">
        <table class="table table-bordered table-user">
          <tbody>
            <tr>
              <td>Họ tên</td>
              <td>{{ userComputed.name }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{{ userComputed.email }}</td>
            </tr>
            <tr>
              <td>Số nhánh</td>
              <td>
                <button
                  v-if="userComputed.ext"
                  v-b-tooltip="'Nhấn để gọi nội bộ'"
                  class="button button-to-link"
                  @click="makeCall(userComputed.ext)"
                >
                  <i class="icon12-phone-volume-primary"></i>
                  {{ userComputed.ext }}
                </button>
                <span v-else>Không rõ</span>
              </td>
            </tr>
            <tr>
              <td>SĐT</td>
              <td>
                <button
                  v-if="userComputed.phone"
                  v-b-tooltip="'Nhấn để gọi'"
                  class="button button-to-link"
                  @click="makeCall(userComputed.phone)"
                >
                  <i class="icon12-phone-volume-primary"></i>
                  {{ userComputed.phone }}
                </button>
                <span v-else>Không rõ</span>
              </td>
            </tr>
            <tr>
              <td>Online lần cuối</td>
              <td>
                <span v-if="userComputed.lastOnlineTime">{{
                  userComputed.lastOnlineTime | moment('DD/MM/YY HH:mm:ss')
                }}</span>
                <span v-else>Chưa online lần nào</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </button>
</template>

<style lang="scss" scoped>
.button-to-link.button-to-link {
  background: none;
  border: none;
  color: #6b66c4;
  cursor: pointer;
  font-weight: 500;
  padding: 0;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.table-user.table-user {
  & td:first-child {
    text-align: right;
    font-weight: bold;
  }
}
</style>

<script>
export default {
  props: {
    user: {
      type: Object,
    },
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    userComputed() {
      return typeof this.user === 'object' ? this.user : null;
    },
  },
  methods: {
    makeCall(number) {
      this.$bus.$emit('makeCall', number);
    },
  },
};
</script>
